"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rerenderer = void 0;
const react_1 = __importStar(require("react"));
const react_2 = __importDefault(require("@monaco-editor/react"));
const config_1 = __importDefault(require("next/config"));
const state_1 = require("@amzn/monera-app-core/lib/state");
const utils_1 = require("@amzn/monera-app-core/lib/utils");
const button_1 = require("../button");
const modal_1 = require("../modal");
const styles_1 = require("./styles");
const Rerenderer = (props) => {
    const { 'aria-label': ariaLabel, copy } = props;
    const [configStoreState, configStoreActions] = (0, state_1.useConfigStore)();
    const componentDefinitionSample = configStoreState.layout;
    const [editorValue, setEditorValue] = (0, react_1.useState)(JSON.stringify(componentDefinitionSample, null, 2));
    const [modalOpen, setModalOpen] = (0, react_1.useState)(false);
    const handleCloseModal = () => {
        setModalOpen(false);
    };
    const handleOpenModal = () => {
        setModalOpen(true);
    };
    const handleEditorChange = (value) => {
        if (value) {
            setEditorValue(value);
        }
    };
    const handleClick = () => {
        let json;
        try {
            json = JSON.parse(editorValue);
            configStoreActions.update({ layout: json });
            setModalOpen(false);
        }
        catch (_a) {
            utils_1.serverConsole.log('Unable to parse JSON');
        }
    };
    const shallRenderMoneraTools = () => {
        const config = (0, config_1.default)();
        if ((0, utils_1.isClientSide)() && config) {
            const { publicRuntimeConfig } = config;
            return publicRuntimeConfig.envStage !== 'prod';
        }
        return false;
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, shallRenderMoneraTools() && (react_1.default.createElement("div", null,
        react_1.default.createElement(styles_1.FloatingActionButton, { "aria-label": ariaLabel, onClick: handleOpenModal }, copy),
        react_1.default.createElement(modal_1.Modal, { isOpen: modalOpen, close: handleCloseModal },
            react_1.default.createElement("div", null,
                react_1.default.createElement(styles_1.EditorWrapper, null,
                    react_1.default.createElement(react_2.default, { defaultLanguage: "json", theme: "vs-dark", defaultValue: editorValue, onChange: handleEditorChange })),
                react_1.default.createElement(styles_1.ButtonWrapper, null,
                    react_1.default.createElement(button_1.Button, { width: "100px", "aria-label": "Re-Render", copy: "Re-Render", onClick: handleClick }))))))));
};
exports.Rerenderer = Rerenderer;
